/* 🤖 this file was generated by svg-to-ts */
export const mgcIconPencilCuteFi: {
  name: 'pencil-cute-fi';
  data: string;
} = {
  name: 'pencil-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.6 2.385c-.818.157-1.434.498-2.08 1.152l-.339.344 2.471 2.469 2.472 2.47.428-.442c.452-.468.611-.698.829-1.205.206-.48.274-.893.246-1.492-.034-.736-.196-1.224-.61-1.842-.419-.624-1.182-1.162-1.957-1.379-.236-.066-1.238-.117-1.46-.075M9.457 9.61c-4.568 4.577-4.494 4.496-4.87 5.253-.25.502-.294.654-.773 2.717-.463 1.993-.491 2.197-.344 2.48.098.189.295.383.49.482.262.133.506.098 2.46-.356 2.061-.479 2.212-.522 2.72-.775.759-.379.674-.301 5.25-4.868l4.331-4.323-2.471-2.47-2.471-2.47z"/></svg>`
};
